import { Injectable } from '@angular/core';
import { BaseChainBaseGuard } from '../../internal';

@Injectable({
  providedIn: 'root'
})
export class ResetQuizSharedGuard extends BaseChainBaseGuard {
  override async canActivate(): Promise<boolean> {
    return new Promise((resolve) => {
      this.baseChainGuardFacade.requestResetQuiz().subscribe(() => {
        resolve(true);
      });
    });
  }
}
